declare namespace $ {

	type __shm_hitalama_map_widget_float_table_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_table['cell_content_text'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_widget_float_table['Table'] >['cell_content_text'] >[0]
	>
	type $mol_grid__records_shm_hitalama_map_widget_float_table_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['rows'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_ids_shm_hitalama_map_widget_float_table_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__col_head_content_shm_hitalama_map_widget_float_table_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	type $mol_grid__Cell_shm_hitalama_map_widget_float_table_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['Cell'] >
		,
		ReturnType< $mol_grid['Cell'] >
	>
	type $mol_button_copy__sub_shm_hitalama_map_widget_float_table_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_copy['sub'] >
	>
	type $mol_button_copy__text_shm_hitalama_map_widget_float_table_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_content_text_str'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_download__uri_shm_hitalama_map_widget_float_table_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_file_uri'] >
		,
		ReturnType< $mol_button_download['uri'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_table_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__sub_shm_hitalama_map_widget_float_table_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_download['sub'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_table_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_table_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['delete_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_number__Dec_shm_hitalama_map_widget_float_table_21 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_widget_float_table_22 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_table_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['col_width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_table_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_table_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['chart_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['echarts_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_table_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_table_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['tabulator_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_hitalama_map_widget_float_table_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__sub_shm_hitalama_map_widget_float_table_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_check_group__checks_shm_hitalama_map_widget_float_table_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table['cell_checkboxes'] >
		,
		ReturnType< $mol_check_group['checks'] >
	>
	export class $shm_hitalama_map_widget_float_table extends $shm_hitalama_map_widget_float {
		rows( ): Record<string, any>
		col_ids( ): readonly(any)[]
		col_head_content( id: any): readonly(any)[]
		cell_content_text( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table['Table'] >['cell_content_text'] >
		Cell( id: any): $mol_view
		table_row_ids( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_table['Table'] >['row_ids'] >
		Table( ): $mol_grid
		Copy_icon( id: any): $mol_icon_content_copy
		cell_content_text_str( id: any): string
		Cell_copy( id: any): $mol_button_copy
		Copy_area( id: any): $mol_view
		col_width_px( id: any): string
		cell_style( id: any): ({ 
			'maxWidth': ReturnType< $shm_hitalama_map_widget_float_table['col_width_px'] >,
			'width': ReturnType< $shm_hitalama_map_widget_float_table['col_width_px'] >,
		}) 
		cell_file_uri( id: any): string
		cell_file_name( id: any): string
		Download_icon( id: any): $mol_icon_download
		Download( id: any): $mol_button_download
		cell_file_visible( id: any): readonly(any)[]
		cell_index_number( id: any): string
		cell_checked( id: any, next?: boolean ): boolean
		Checkbox( id: any): $mol_check_box
		cell_delete( id: any, next?: any ): any
		Action_delete( id: any): $mol_button_minor
		cell_delete_visible( id: any): readonly(any)[]
		cell_edit( id: any, next?: any ): any
		Action_edit( id: any): $mol_button_minor
		cell_checkboxes( ): readonly(any)[]
		delete_enabled( next?: boolean ): boolean
		Deleting( ): $mol_check_box
		deleting_tool_visible( ): readonly(any)[]
		Col_widths_head( ): $mol_view
		Col_width_title( id: any): $mol_view
		col_width( id: any, next?: number ): number
		Col_width( id: any): $mol_number
		Col_width_row( id: any): $mol_view
		col_width_rows( ): readonly(any)[]
		chart_add( next?: any ): any
		Chart_add( ): $mol_button_minor
		echarts_add( next?: any ): any
		Echarts_add( ): $mol_button_minor
		tabulator_add( next?: any ): any
		Tabulator_add( ): $mol_button_minor
		controls( ): readonly(any)[]
		Cell_text( id: any): $mol_grid_cell
		Cell_file( id: any): $mol_grid_cell
		Cell_index_number( id: any): $mol_grid_cell
		Cell_checkbox( id: any): $mol_grid_cell
		Cell_delete( id: any): $mol_grid_cell
		Cell_edit( id: any): $mol_grid_cell
		All_check( ): $mol_check_group
		checkboxes_showed( ): boolean
		tools_custom( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map